import { combineReducers } from "redux";
import { PaymentState } from "./state";
import { retrievePaymentSessionReducer } from "../usecases/retrievePaymentSession/reducer";
import { validatePaymentReducer } from "../usecases/validatePayment/reducer";

export const PaymentRootReducer = combineReducers<PaymentState>({
    retrieveSession: retrievePaymentSessionReducer,
    validatePayment: validatePaymentReducer
})
